/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationIPWhitelistResponseData
 */
export interface CreateOrganizationIPWhitelistResponseData {
    /**
     * 
     */
    organization_id?: string;
    /**
     * 
     */
    ip_address?: string;
}

/**
 * Check if a given object implements the CreateOrganizationIPWhitelistResponseData interface.
 */
export function instanceOfCreateOrganizationIPWhitelistResponseData(value: object): value is CreateOrganizationIPWhitelistResponseData {
    return true;
}

export function CreateOrganizationIPWhitelistResponseDataFromJSON(json: any): CreateOrganizationIPWhitelistResponseData {
    return CreateOrganizationIPWhitelistResponseDataFromJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationIPWhitelistResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'ip_address': json['ip_address'] == null ? undefined : json['ip_address'],
    };
}

export function CreateOrganizationIPWhitelistResponseDataToJSON(json: any): CreateOrganizationIPWhitelistResponseData {
    return CreateOrganizationIPWhitelistResponseDataToJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistResponseDataToJSONTyped(value?: CreateOrganizationIPWhitelistResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'ip_address': value['ip_address'],
    };
}

